<template>
	<div id="banner" ref="FOtherBanner" style="overflow: hidden;">
		<div arrow="always" >
			<!-- <el-carousel-item v-for="(item,index) in imgList" :key="index"> -->
				<img src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/otherTitle.png" ref="bannerImg" @load="imgLoad" :style="{width:totalWidth+'px',height:bannerHeight+'px'}">
				<div class="fbannerUpText" :style="{position:'absolute',top:'200px',left:' 300px',color:'white','font-weight':600,'font-size':(totalWidth/50)+'px'}">{{name1}}</div>
				<div class="fbannerBottomText" :style="{position:'absolute',top:'270px',left:' 300px',color:'white','font-size':(totalWidth/70)+'px'}">{{name2}}</div>
			<!-- </el-carousel-item> -->
		</div>
	</div>
</template>

<script>
	import {queryImageByStatus} from "@/api/front";
	export default {
		props: {
			name1: {
				type: String,
				require: ''
			},
			name2: {
				type: String,
				require: ''
			},
		},
		data() {
			return {
				/* 轮播图变量 */
				imgList: [],
				bannerHeight: '', // 图片父容器高度
				bannerWidth: '', //图片父容器宽度
				totalWidth:window.screen.width,
				// totalWidth:window.screen.width * window.devicePixelRatio,
				windowHeight: document.body.clientHeight,
				windowWidth: document.body.clientWidth
			}
		}, watch: {
			// 监听页面高度
			windowHeight(val) {
				console.log('实时屏幕高度', val, this.windowHeight)
			},
			// 监听页面宽度
			windowWidth(val) {
				window.location.reload()
				console.log('实时屏幕宽度', val, this.windowHeight)
			}
		},
		mounted() {
			// this.queryBannerImage()
			window.onresize = () => {
				return (() => {
					this.windowHeight = document.documentElement.clientHeight;
					this.windowWidth = document.documentElement.clientWidth
				})()
			}
			console.log(this.totalWidth)
				console.log('屏幕',this.$refs.FOtherBanner.offsetWidth)
				this.totalWidth = this.$refs.FOtherBanner.offsetWidth
				this.bannerWidth = this.$refs.FOtherBanner.offsetWidth
		},
		methods: {
			imgLoad() {
				this.$nextTick(() => {
					this.bannerHeight = this.$refs.bannerImg.height;
					this.bannerWidth = this.$refs.bannerImg.width;
					console.log(this.totalWidth)
				})
			},
		},

	}
</script>

<style lang="scss" scoped>
	@keyframes moveLeftToRight{
		from{transform: translateX(300%);}
		to{transform: translateX(0%);}
	}
	.fbannerUpText{
		animation: moveBottomToUp 2s ease-out forwards;
	}
	@keyframes moveBottomToUp{
		from{transform: translateY(1000%);}
		to{transform: translateY(0%);}
	}
	.fbannerBottomText{
		animation: moveBottomToUp 2s ease-out forwards;
	}

/* 定义size-up动画，使元素从初始状态缩放到35倍大小 */
		@keyframes sizeup {
			from {
				transform: scale(1); /* 初始状态，将元素缩小10倍 */
			}
			to {
				transform: scale(1.1); /* 终止状态，将元素放大35倍 */
			}
		}
		/* 将size-up动画添加到img元素中，使图片缩放到35倍大小 */
		img {
				animation: sizeup 2s ease-out forwards; /* 动画持续时间为6秒，并在动画结束后保持最终状态 */
		}
	#banner{
		// border-radius: 0 0 50px 50px;
		// overflow: hidden;
	}
</style>
